import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F8F9FA]" data-testid="route-loading">
        <Loader2 className="animate-spin text-slate-400" size={22} />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
